import { useGetAvailableVendorsQuery } from '@/common/infrastructure/gql/generated/schema';

const useAvailableVendors = () => {
  const { data, loading } = useGetAvailableVendorsQuery({ skip: false });

  return {
    loading,
    availableVendors: data?.raptorJobSupportingDataQuery.value.availableVendors ?? []
  };
};

export default useAvailableVendors;
